<template>
  <div class='delStatusInfo'>
    <div class="deal_state_icon">
      <template>
        <div style="float: left;">
          <i class="el-icon-error" v-show="info.status==10"></i>
          <i class="el-icon-success" v-show="info.status==9 || info.status==12 || info.status==7 || info.type==2 && info.result"></i>
          <img
            src="../../../assets/img/other/await_icon.png"
            alt
            class="await_icon"
            v-show="info.status!=10&&info.status!=9&&info.status!=12&&info.status!=7 && !info.type"
          />
          <img
            src="../../../assets/img/other/await_icon.png"
            alt
            class="await_icon"
            v-show="info.type==2 && !info.result"
          />
        </div>
        <div style="float: left;">
          <div v-if="info.type!=2">
            <span v-if="!otherType">{{info.status|getStatusNme(assignLoginType)}}</span>
            <span v-else>{{info.status|getStatusNme(assignLoginType,otherType)}}</span>
          </div>
          <div v-else>
            <span v-if="info.type==2 && info.result">
              已处理
            </span>
            <span  v-if="info.type==2 && !info.result">
              待处理
            </span>
          </div>
        </div>
      </template>
    </div>
    <div class="status_info_info" style="clear: both;">
      <!--可二次申诉/已结案-->
      <div v-show="info.status==7||info.status==9||(!info.status&&info.type===2&&info.result)">
        <div>处理时间: {{info.updatetime| fullTime}}</div>
        <div>处理结果:{{info.result}}</div>
      </div>
      <!--处理中-->
      <div
        v-show="info.status==5||info.status==8"
      >
        <div>申诉时间:{{info.flowtime| fullTime}}</div>
        <div class="ellipsis_row">申诉理由:{{info.reportexplain}}</div>
      </div>
      <!-- 举报驳回-->
      <div v-show="info.status==10">
        <div>处理时间: {{info.flowtime| fullTime}}</div>
        <div>驳回说明:{{info.reportexplain}}</div>
      </div>
      <!-- 已处理 -->
       <div v-show="info.status==12 || info.type==2 && info.result">
        <div>处理时间: {{info.updatetime| fullTime}}</div>
        <div>处理方式:{{info.result}}</div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  props: {
    info: {
      type: Object,
      required: true
    },
    assignLoginType:{
      type:String
    },
    otherType:{
       type: String,
       default:'',
    }
  }
};
</script>
